import React from 'react'
import styled from '@emotion/styled'
import { parseTelNumbers } from '../../../utils/parseTelNumbers'

const Wrap = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  flex: 1;
`

const Link = styled.a`
  display: block;
  word-break: break-all;
  color: inherit;
`

type Props = {
  tel: string | null | undefined
}

/** DB の改行区切りなどを分解し、番号ごとに tel: リンクを縦に並べる */
export const TelLinkList = ({ tel }: Props) => {
  const nums = parseTelNumbers(tel)
  if (nums.length === 0) {
    return <>-</>
  }
  return (
    <Wrap>
      {nums.map((num, i) => (
        <Link key={i} href={`tel:${num}`}>
          {num}
        </Link>
      ))}
    </Wrap>
  )
}
